var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.854,
    height: 13.228,
    viewBox: "0 0 15.854 14.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Org_Map",
    "data-name": "Org Map",
    transform: "translate(-826.994 -430.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_tree_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24_1_",
    "data-name": "account_tree_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24 (1)",
    d: "M100.569-815.772v-2.439H97.317v-8.13H95.285v2.439H90V-830h5.285v2.439h5.285V-830h5.285v6.1h-5.285v-2.439H98.537v6.911h2.033v-2.439h5.285v6.1Zm-9.35-13.008v0Zm10.569,8.13v0Zm0-8.13v0Zm0,3.659h2.846v-3.659h-2.846Zm0,8.13h2.846v-3.659h-2.846Zm-10.569-8.13h2.846v-3.659H91.22Z",
    transform: "translate(736.994 1260.887)",
    fill: "#072945"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgMap);
export default __webpack_public_path__ + "static/media/org_map.bcb1e379c3ec7d395d5924a416763a20.svg";
export { ForwardRef as ReactComponent };